import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import { IdSchema } from '../../../resource-base/baseSchemas';
import {
    defaultNamedParentedPersistableResource,
    NamedParentedPersistableResourceSchema,
} from '../../../resource-base/persistableResourceTypes';

export enum ProjectUserGroupPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    USERS = 'USERS',
    SYSTEM_USER_GROUPS = 'SYSTEM_USER_GROUPS',
    PROJECT_USER_GROUPS = 'PROJECT_USER_GROUPS',
    USER_WILDCARD_MATCHER = 'USER_WILDCARD_MATCHER',
}

export const ProjectUserGroupResourceSchema = NamedParentedPersistableResourceSchema.extend({
    description: z.string(),
    users: IdSchema.array(),
    systemUserGroups: IdSchema.array(),
    projectUserGroups: IdSchema.array(),
    userWildcardMatcher: z.string().nullable(),
    resourceType: z.literal(ResourceType.PROJECT_USER_GROUP).default(ResourceType.PROJECT_USER_GROUP),
});

export const ProjectUserGroupMutationResourceSchema = getMutationSchema(ProjectUserGroupResourceSchema);

export type ProjectUserGroupResource = z.infer<typeof ProjectUserGroupResourceSchema>;

export const defaultProjectUserGroupResource: ProjectUserGroupResource = {
    ...defaultNamedParentedPersistableResource,
    resourceType: ResourceType.PROJECT_USER_GROUP,
    description: '',
    users: [],
    systemUserGroups: [],
    projectUserGroups: [],
    userWildcardMatcher: null,
};

export function useProjectUserGroupActions() {
    return useMultiResourceSingleParentedResourceAdapterActions(
        'project-user-group',
        ResourceType.PROJECT_USER_GROUP,
        ProjectUserGroupResourceSchema
    );
}
